import axios from "axios";
// https://admin.dcp.am/
export const baseApi = 'https://admin-api.dcp.am/api'

export const Api = axios.create({
    baseURL:baseApi
})